import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";
import { useState, useRef, useEffect } from "react";
import { api } from "@/lib/api";

const LANGS = [
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
];

export default function LanguageSwitcher({ compact = false }) {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANGS.find((l) => l.code === i18n.language.split("-")[0]) || LANGS[0];

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const change = (code) => {
    setOpen(false);
    if (code === current.code) return;
    i18n.changeLanguage(code);
    api.post("/auth/lang", { lang: code }).catch(() => {}).finally(() => window.location.reload());
  };

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid="lang-switcher-button"
        className="flex items-center gap-1.5 px-2 py-1.5 rounded-lg text-sm font-medium text-text-secondary hover:text-[var(--text)] hover:bg-[var(--surface-2)] transition-colors"
      >
        <Languages className="w-4 h-4" />
        {!compact && <span className="uppercase">{current.code}</span>}
      </button>
      {open && (
        <div
          data-testid="lang-switcher-menu"
          className="absolute right-0 mt-2 w-40 rounded-xl border border-c bg-[var(--surface)] shadow-lg overflow-hidden z-50"
        >
          {LANGS.map((l) => (
            <button
              key={l.code}
              type="button"
              onClick={() => change(l.code)}
              data-testid={`lang-option-${l.code}`}
              className={`w-full text-left px-3 py-2 text-sm flex items-center gap-2 hover:bg-[var(--surface-2)] ${l.code === current.code ? "font-semibold text-[var(--text)]" : "text-text-secondary"}`}
            >
              <span>{l.flag}</span>
              <span>{l.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
